import React,{Component} from "react";
import Header from "../../components/Header";
import { Grid, TextField, Typography } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Grade';
import Fab from '@material-ui/core/Fab';
import {
  primaryColor,
  webFont
} from "../../config/theme";
import {compose, graphql} from "react-apollo/index";
import {client} from '../../config/apollo';
import {connect} from "react-redux";
import {getUserReviewTags, getChefReviewTags, getUser} from "../../redux/user";
import {SUBMIT} from "../../graphql/mutations/review";
import {GET_REVIEW} from '../../graphql/queries/reviews';
import {NotificationManager} from "react-notifications";
import { GET_CHEF_DETAILS } from "../../graphql/queries/chef";
import { USER_PROFILE } from "../../graphql/queries/user";
import Breadcrumbs from "../Breadcrumbs";

class Review extends Component {
  state={
    review:[1,2,3,4,5],
    starReview:'',
    selectedReviewTag:[],
    message:'',
    booking:'',
    exReview: null,
    chef: null
  };

  componentDidMount(){
    if (!this.props.location.state) {
      return this.props.history.push("/home");
    }

    const {
      location: {
        state: { booking }
      }
    } = this.props;

    this.setState({booking});

    const { dispatch, userId, isChef } = this.props;
    let reviewToFetch = userId;

    const payload = {}
    if (isChef) {
      payload.userId = booking.userId;
    } else {
      payload.id = booking.chefId;
    }
    client
      .query({
        query: isChef ? USER_PROFILE : GET_CHEF_DETAILS,
        variables: payload
      })
      .then(resp => {
        this.setState({ chef: isChef ? resp.data.userProfile : resp.data.chef });
      })
      .catch(err => console.error('ERR FETCHING CHEF FOR REVIEW: ', err))

    client
      .query({
        query: GET_REVIEW,
        variables: {
          filters: {
            bookingId: booking.id,
            reviewType: isChef ? 'USER' : 'CHEF',
          },
          pageSize: 1,
          next: null,
          previous: null,
        },
        fetchPolicy: 'network-only'
      })
      .then(response => {
        if (!!response.data && !!response.data.reviews) {
          const {reviews} = response.data.reviews;

          if(reviews.length > 0) {
            const review = reviews[0];
            this.setState({exReview: review, message: review.body, starReview: review.rating, selectedReviewTag: review.tags});
          }
        }
      })
      .catch(error => {});

    if (isChef) {
      dispatch(getChefReviewTags(reviewToFetch));
    }
    else {
      reviewToFetch = booking.userId;
      dispatch(getUserReviewTags(reviewToFetch));
    }
    dispatch(getUser(userId));

  }

  handleStarReviewClick = review =>{
    let starReview=review;
    this.setState({starReview});
  };

  handleReviewClick = review =>{
    let {selectedReviewTag}=this.state;
    let index = selectedReviewTag.indexOf(review);
    if(index == -1){
      selectedReviewTag.push(review);
    }else{
      selectedReviewTag.splice(index, 1);
    }
    this.setState({selectedReviewTag});
  };

  handleMessageChange = e =>{
    let message=e.target.value;
    this.setState({message});
  };

  submitReview=()=>{
    const { submitReview,userId,diner, isChef } = this.props;
    let {starReview,selectedReviewTag,message,booking}=this.state;
    if(starReview) {
      let payload = {
        reviewer: diner.id,
        reviewerName: `${diner.firstName} ${diner.lastName}`,
        reviewType: isChef ? 'USER' : 'CHEF',
        reviewee: booking.chefId,
        rating: starReview,
        body: message,
        tags: selectedReviewTag,
        bookingId: booking.id
      };

      submitReview({
        variables: {
          review: payload

        }
      })
        .then(res => {
          NotificationManager.info("Review Submitted");
          const {isChef} = this.props;
          if (isChef) {
            this.props.history.push('/home/chef-bookings?step=3');
          } else {
            this.props.history.push('/home/diner-bookings?step=3');
          }
        })
        .catch(err => {
          console.log(JSON.parse(JSON.stringify(err)));
          let errorObj = JSON.parse(JSON.stringify(err));
          if (errorObj.graphQLErrors) {
            errorObj.graphQLErrors.map(error => {
              NotificationManager.error(error.message, "Booking");
            });
          }
        });
    }else{
      NotificationManager.error("Review has not been given");
    }

  };

  render() {
    let {starReview,selectedReviewTag}=this.state;
    let {chefReview, isChef, userReview}=this.props;

    let customReview=[];
    let starReviews = this.state.review.map(review => {
      return (
        <div key={review.id}>
          <Grid item xs={2}>
            <Grid container  spacing={1}>
              <Button
              data-test-id={"revstar-id"}
                variant={starReview==review ? "contained" : "outlined"}
                color={"primary"}
                aria-label="Add"
                style={starReview==review ?styles.ratingIcon : {...styles.ratingIcon,color:primaryColor}}
                onClick={() => this.handleStarReviewClick(review)}
              >
                <SaveIcon style={{...styles.leftIcon, ...styles.iconSmall}} />
                {review}
              </Button>
            </Grid>
          </Grid>
        </div>
      );
    });

    if(!!userReview && userReview.length > 0) {
      customReview = userReview.map(review => {
        return (
          <div>
            <Grid item xs={2}>
              <Grid container spacing={1}>
                <button
                 data-test-id={"revbutton-id"}
                  aria-label="Add"
                  style={!!review && selectedReviewTag.indexOf(review) == -1 ? styles.selectedReviewOutlined :  styles.selectedReview}
                  onClick={() => this.handleReviewClick(review)}
                >
                  {review}
                </button>
              </Grid>
            </Grid>
          </div>
        );
      });
    }
    else if(!!chefReview && chefReview.length > 0) {
      customReview = chefReview.map(review => {
        return (
          <div key={review.id}>
            <Grid item xs={2}>
              <Grid container spacing={1}>
                <button
                 data-test-id={"revbutton-id"}
                  aria-label="Add"
                  style={!!review && selectedReviewTag.indexOf(review) == -1 ? styles.selectedReviewOutlined :  styles.selectedReview}
                  onClick={() => this.handleReviewClick(review)}
                >
                  {review}
                </button>
              </Grid>
            </Grid>
          </div>
        );
      });
    }

    return (
      <div className="saved-item-container-review">
        <div>
          <Header history={this.props.history} />
        </div>
        <Grid className="review-container">
          <Grid container>
            <Grid style={{ marginLeft: -10 }}>
              <Breadcrumbs childRoutes={[
                {
                  display: 'Bookings',
                  link: isChef ? 'home/chef-bookings' : 'home/diner-bookings?step=2'
                },
                {
                  display: 'Review',
                  link: 'home/review'
                }
              ]} />
            </Grid>
            <Grid item xs={12}>
              <Typography
                style={{
                  ...styles.setFont,
                  fontSize: 24,
                  fontWeight: 600,
                  marginBottom: 10
                }}
              >
                {isChef ? 'Patron' : 'Crafter'} rating & review
              </Typography>
              <Typography
                style={{
                  ...styles.setFont,
                  fontSize: 18,
                  fontWeight: 'normal',
                  marginBottom: 20
                }}
              >
                How did you find the experience with {this.state.chef ? `${this.state.chef.firstName} ${this.state.chef.lastName ? this.state.chef.lastName : ''}` : isChef ? 'the diner' : 'the chef'}?
              </Typography>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                {starReviews}
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  style={{
                    ...styles.setFont,
                    fontSize: 18,
                    fontWeight: 'normal',
                    marginBottom: 20,
                    marginTop: 20
                  }}
                >
                  Review
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                {customReview}
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid  data-test-id={"revtext-id"} item xs={11}>
              <div
                style={{
                  padding: '20px 0',
                  opacity: 0.62,
                  borderRadius: 2,
                  borderWidth: 1,
                  borderColor: "#979797"
                }}
              >
                <TextField
                  fullWidth
                  id="outlined-with-placeholder"
                  multiline={true}
                  rows="3"
                  placeholder="Tell chef about the nature and purpose of the engagement"
                  margin="normal"
                  variant="outlined"
                  onChange={(e)=>{this.handleMessageChange(e)}}
                  value={this.state.message}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid data-test-id={"revsubmit-id"} item xs={6} alignItems='center'>
              {!this.state.exReview && <Fab
                variant="extended"
                color={primaryColor}
                aria-label="Add"
                style={{...styles.submitReview,textAlign:'center'}}
                onClick={() => this.submitReview()}
              >
                Submit
              </Fab>}
            </Grid>
          </Grid>
        </Grid>
      </div>


    );
  }
}


const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    chefReview: state.user.chefReview,
    userReview: state.user.userReview,
    diner: state.user.diner,
    chef: state.user.chef
  };
};

const ReviewWithData = compose(
  graphql(SUBMIT, { name: "submitReview" })
)(Review);
const ReviewTags = connect(mapStateToProps)(ReviewWithData);
export default ReviewTags;

const styles = {
  setFont: {
    fontFamily: webFont
  },
  setColor: {
    backgroundColor: primaryColor
  },
  button: {
    margin: 10,
  },
  leftIcon: {
    marginRight: 10,
  },
  rightIcon: {
    marginLeft: 10,
  },
  iconSmall: {
    fontSize: 20,
  },
  ratingIcon :{
    borderRadius: 32,
    width:56,
    height:32,
    color: 'white',
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:14
  },
  submitReview :{
    borderRadius: 32,
    backgroundColor: primaryColor,
    height:32,
    border: "none",
    color: "white",
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:16
  },
  selectedReview :{
    borderRadius: 40,
    backgroundColor: primaryColor,
    height:32,
    color: 'white',
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:16,
    border:'none',
    paddingRight:10,
    paddingLeft:10,

  },
  selectedReviewOutlined :{
    borderRadius: 40,
    backgroundColor: 'white',
    height:32,
    color: primaryColor,
    fontFamily: webFont,
    textTransform: "none",
    margin:5,
    fontSize:16,
    paddingRight:10,
    paddingLeft:10,
    borderColor: primaryColor,
    borderStyle: 'solid'
  }

};

